/**
 * Created by vendy
 */

export default {
    WEBSOCKET_CONNECTED: "WEBSOCKET_CONNECTED",
    WEBSOCKET_DOLAUNCH: "WEBSOCKET_DOLAUNCH",
    VERIFYCOOKIE_PASS: "VERIFYCOOKIE_PASS",
    VERIFYTOKEN_PASS: "VERIFYTOKEN_PASS",
    WS_REGISTER_GROUP_RSP: "WS_REGISTER_GROUP_RSP",
    WS_UNREGISTER_GROUP_RSP: "WS_UNREGISTER_GROUP_RSP",
    WS_UPDATE_USER_EXPS_RSP: "WS_UPDATE_USER_EXPS_RSP",
    WS_CONNET_STATE:"WS_CONNET_STATE",
    WS_URI_NOTICE:"WS_URI_NOTICE",
    EXT_TAF_DATA:"extTafData",
    CLOUD_GAME_DATA:"CLOUD_GAME_DATA"
};